export const Textarea = {
  baseStyle: {
    width: '100%',
    height: '100%',
    padding: '10px 16px',
    textColor: 'input.text',
    outlineOffset: '0',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'input.border',
    borderRadius: '15px',

    _placeholder: { color: 'input.placeholder' },
  },
  sizes: {
    md: {
      minHeight: '80px',
    },
  },
  variants: {
    primary: {
      _hover: {
        boxShadow: 'none',
        borderColor: 'input.borderHover',
        borderWidth: '2px',
        margin: '0 -1px',
      },
      _focus: {
        boxShadow: 'none',
        borderWidth: '2px',
        borderColor: 'brand.accent',
        margin: '0 -1px',
      },
    },
    error: {
      borderWidth: '2px',
      borderColor: 'brand.error',
      margin: '0 -1px',
      _hover: {
        boxShadow: 'none',
        borderColor: 'brand.error',
        borderWidth: '2px',
        margin: '0 -1px',
      },
      _focus: {
        boxShadow: 'none',
        borderWidth: '2px',
        borderColor: 'brand.error',
        margin: '0 -1px',
      },
    },
  },
  defaultProps: {
    variant: 'primary',
    size: 'md',
  },
}
